export const getFileType = (
  sourceUrl?: string,
): "ppt" | "xls" | "csv" | "doc" | "pdf" | "unknown" => {
  const extension = sourceUrl?.split(".").pop()?.toLowerCase();
  switch (extension) {
    case "ppt":
    case "pptx":
      return "ppt";
    case "xls":
    case "xlsx":
      return "xls";
    case "csv":
      return "csv";
    case "doc":
    case "docx":
      return "doc";
    case "pdf":
      return "pdf";
    default:
      return "unknown";
  }
};
